import getSelectedElementUuids from 'editor/src/store/editor/selector/getSelectedElementUuids';
import { RootState } from 'editor/src/store/index';

import getMediaElementsByUuids from './getMediaElementsByUuids';

const getSelectedMediaElementsObjects = (state: RootState) =>
  getMediaElementsByUuids(state, getSelectedElementUuids(state));

export default getSelectedMediaElementsObjects;
